import type { SwidgeProviderName } from '@infinex/actions';
import { FrameInspectIcon } from '@infinex/ui-icons';

import { PROVIDER_ICONS } from './swidge/quotes/constants';

export type SwidgeProviderExplorerLinkProps = {
  dimOnUndefined?: boolean;
  providerName: SwidgeProviderName;
  href?: string | null;
};

export function SwidgeProviderExplorerLink({
  dimOnUndefined = true,
  href,
  providerName,
}: SwidgeProviderExplorerLinkProps) {
  // If no explicit providerExplorerInfo is provided, try to infer it from the action
  return href ? (
    <a
      target="_blank"
      href={href}
      className="hover:fill-emphasis hover:text-emphasis text-default fill-default group flex flex-row items-center"
    >
      <img
        src={PROVIDER_ICONS[providerName]}
        className="size-5"
        alt={providerName}
      />
      <FrameInspectIcon className="bg-surfaceTwo z-10 -ml-1 size-7 rounded-sm p-1" />
    </a>
  ) : (
    <div
      style={{ opacity: dimOnUndefined ? '50%' : undefined }}
      className="group flex flex-row items-center"
    >
      <img src={PROVIDER_ICONS[providerName]} className="size-5" alt="" />
      <FrameInspectIcon className="bg-surfaceTwo z-10 -ml-1 size-7 rounded-sm p-1" />
    </div>
  );
}
